// extracted by mini-css-extract-plugin
module.exports = {"page_title":"OrderOverviewPage_page_title__1KZ38","button":"OrderOverviewPage_button__QeHiT"};